export default __webpack_public_path__ + "static/media/AdwoaLovelace.6595c31e.png";